import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './tabs.module.scss'

export const handleChange = (tab, setValue, onChange) => {
  setValue(tab.id)

  if (onChange) onChange(tab)
}

export const handleClear = (initialValue, setValue) => {
  setValue(initialValue)
}

const Tabs = (props) => {
  const { tabs, initialValue, onChange } = props

  const initialActive = tabs.find((tab) => tab.id === initialValue)

  const [value, setValue] = useState(initialActive)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const tabsComponent = tabs.map((tab) => {
    const isActive = tab.id === value

    const tabClass = classNames(styles.tab, { [styles.active]: isActive })

    return (
      <div
        key={tab.id}
        className={tabClass}
        onClick={() => {
          handleChange(tab, setValue, onChange)
        }}
      >
        {tab.name}
      </div>
    )
  })

  return <div className={styles.tabs}>{tabsComponent}</div>
}

Tabs.defaultProps = {
  onChange: null,
  tabs: [],
  initialValue: null
}

Tabs.propTypes = {
  onChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ),
  initialValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Tabs
